/* disable-scroll-on-number-input.js */

/** for chrome-behavior: detects if there is scrolling on an <input type="number"> and prevents increasing the number on scroll */

export default function disableScrollOnNumberInput() {
    document.addEventListener('wheel', function (e) {
        if (document.activeElement.type === 'number') {
            document.activeElement.blur();
        }
    });
}
